import { axiosInstance as axios } from "services";

export const fetchSyncStatus = async ({ page = 1, limit = 10, filter = "all", search = "" } = {}) => {
  const params = new URLSearchParams({ page, limit, filter });
  if (search) params.append("search", search);
  const { data } = await axios.get(`/pricing/master/sync-status?${params}`);
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch sync status");
  return data.result;
};
